<formly-field
  *ngFor="let field of fields; trackBy: trackField"
  hide-deprecation
  [form]="field.form"
  [options]="field.options"
  snRemoveAriaOwns
  [model]="field.model"
  [field]="field"
>
</formly-field>
<ng-content></ng-content>
